import googleDriveIcon from "../assets/images/chats/googledrive.svg";
import oneDriveIcon from "../assets/images/chats/onedrive_svg.svg";
import driveFolderIcon from "../assets/images/chats/driveFolder.svg";
import onedriveFolderIcon from "../assets/images/chats/onedriveFolder.svg";

// Client-side registry of cloud storage providers. Ids must match the
// backend provider registry (services/cloudStorage). To surface a new
// provider (Dropbox, Box, ...) add it here once the backend implements it —
// the attachment menu and CloudStorageDrawer render from this list.
//
// Beyond id/label/icon, each entry carries a light "theme" (accent color,
// folder icon, search placeholder) and a `views` list — the collections the
// picker's nav rail can switch between (id must match what the provider's
// listFiles() on the backend understands for its `view` param). The first
// view is always the default/root collection; its label doubles as the
// initial breadcrumb root ("My Drive", "My files", ...).
export const CLOUD_STORAGE_PROVIDERS = [
  {
    id: "google-drive",
    label: "Google Drive",
    icon: googleDriveIcon,
    accent: "#1A73E8",
    accentHover: "#1558B0",
    accentSoft: "#E8F0FE",
    folderIcon: driveFolderIcon,
    searchPlaceholder: "Search in Drive",
    views: [
      { id: "root", label: "My Drive" },
      { id: "recent", label: "Recent" },
      { id: "shared", label: "Shared with me" },
      { id: "shared-drives", label: "Shared drives" },
    ],
  },
  {
    id: "onedrive",
    label: "OneDrive",
    icon: oneDriveIcon,
    accent: "#0078D4",
    accentHover: "#106EBE",
    accentSoft: "#E5F1FB",
    folderIcon: onedriveFolderIcon,
    searchPlaceholder: "Search OneDrive",
    views: [
      { id: "root", label: "My files" },
      { id: "recent", label: "Recent" },
      { id: "shared", label: "Shared" },
    ],
  },
];

export const getCloudStorageProviderMeta = (providerId) =>
  CLOUD_STORAGE_PROVIDERS.find((provider) => provider.id === providerId);
